import {planTypes ,trackingPlanTypes} from "@/common/constants";
import {get} from "lodash";

export default {
  key: planTypes['webinar'],
  data() {
    return {
      title: this.$t('billing.webinar.title'),
      subtitle: '',
      capacityKey: 'participants',
      planType: planTypes.WEBINAR,
      description: this.$t('billing.webinar.desc'),
      logo: require('@/assets/plans/webinar.svg'),
      totalLimitDesc: this.$t('billing.licences_limit_tips', ['Zoom Webinars', 'Zoom One']),
      supportCapacity: [500,1000,3000,5000,10000],
    }
  },
  computed: {
    trackingPlanKey() {
      return get(trackingPlanTypes, get(planTypes, this.planType));
    },
  }
};
